import { render, staticRenderFns } from "./ConsultarAditivosConvenio.vue?vue&type=template&id=10949362&scoped=true"
import script from "./ConsultarAditivosConvenio.vue?vue&type=script&lang=ts"
export * from "./ConsultarAditivosConvenio.vue?vue&type=script&lang=ts"
import style0 from "./ConsultarAditivosConvenio.vue?vue&type=style&index=0&id=10949362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10949362",
  null
  
)

export default component.exports